import React, { JSX } from "react";
import styled from "styled-components";

const SubmissionDateStyled = styled.div`
  font-size: 12px;
  text-align: right;
  margin: 0 4px 0 0;
`

const SubmissionDate = (): JSX.Element => {
  const date = new Date();
  return (
    <SubmissionDateStyled>Submission Date: {date.getMonth() + 1}/{date.getDate()}/{date.getFullYear()}</SubmissionDateStyled>
  )
};

export default SubmissionDate;

